import { addStyles } from 'ethcss'
import grid from 'blocks.simple/grid/grid.jcss'
import item from 'blocks.simple/item/item.jcss'
import { textSizes } from 'theme/media'
import { IStyles } from '../../theme'

export const PREVIEW_CAPTION_HEIGHT = 63

const previewStyles: IStyles = {
    wrapper: {
        ...grid.full,
        ...item.previewOpacity,
        overflow: 'hidden',
        position: 'relative',
    },
    contentWrapper: {
        ...grid.full,
        position: 'relative',
        overflow: 'hidden',
        minHeight: 0,
        minWidth: 0,
    },
    textSlide: {
        ...grid.full,
        ...grid.colCenter,
        ...grid.center,
        minWidth: 0,
        minHeight: 0,
        overflow: 'hidden',
    },
    caption: {
        ...item.abs,
        ...grid.fullWidth,
        height: PREVIEW_CAPTION_HEIGHT,
        top: 0,
        zIndex: 2,
        overflow: 'hidden',
        '& span': {
            ...item.whiteColor,
            ...grid.row,
            ...grid.p_md,
            ...item.blackOpacity,
            fontSize: textSizes.mdPlus,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: '100%',
            boxSizing: 'border-box',
            paddingRight: 56,
        },
    },
    navIconWrapper: {
        ...item.abs,
        ...grid.colCenter,
        ...grid.fullHeight,
        ...grid.p_md,
        zIndex: 2,
        pointerEvents: 'none',
    },
    prev: {
        left: 0,
    },
    next: {
        right: 0,
    },
    navIcon: {
        ...item.pointer,
        ...item.circle,
        ...grid.p_md,
        ...item.blackLight,
        zIndex: 2,
        pointerEvents: 'auto',
    },
    controlsWrapper: {
        ...grid.fullWidth,
        ...grid.row,
        ...grid.center,
        ...item.abs,
        bottom: 0,
        zIndex: 2,
    },
    controls: {
        ...grid.row,
        ...grid.mb_md,
        ...item.blackOpacity,
        ...item.rounded_full_normal,
    },
}

addStyles(previewStyles)
export default previewStyles
